export default __webpack_public_path__ + "static/media/(33).db0cf578.jpg";